import { Spinner, Center } from 'native-base';

export default function () {
  return (
    <Center w="100%">
      <Spinner />
    </Center>
  );
}
